import { css, cssManager } from '@design.estate/dees-element';
import { themeDefaultStyles } from '../../00theme.js';
import { chartFrameStyles } from '../dees-chart-echarts-styles.js';

export const chartAreaStyles = [
    themeDefaultStyles,
    cssManager.defaultStyles,
    chartFrameStyles,
    css`
      .chartContainer { margin: 12px 16px 8px; }
      /* compact also drops the content divider; its frame goes through the tile's frameless mode. */
      :host([compact]) dees-tile::part(content) { border: 0; }
      :host([compact]) .chartContainer { margin: 4px 0 0; }
      .rangeSelectionOverlay {
        position: absolute;
        display: none;
        top: 0;
        bottom: 0;
        z-index: 3;
        pointer-events: none;
        background: color-mix(in srgb, var(--dees-color-accent, #3b82f6) 18%, transparent);
        border-inline: 1px solid color-mix(in srgb, var(--dees-color-accent, #3b82f6) 70%, transparent);
      }
      .statsBar {
        min-height: 36px;
        padding: 4px 16px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px 16px;
        width: 100%;
        box-sizing: border-box;
      }
      .statsSeries {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .statsSeries + .statsSeries {
        padding-left: 16px;
        border-left: 1px solid var(--dees-color-border-default);
      }
      .statsColor {
        width: 8px;
        height: 8px;
        border-radius: 2px;
        flex-shrink: 0;
      }
      .statsName {
        font-weight: 500;
        font-size: 12px;
        color: var(--dees-color-text-secondary);
        margin-right: 4px;
      }
      .statsItem {
        font-size: 12px;
        color: var(--dees-color-text-muted);
      }
      .statsItem strong {
        color: var(--dees-color-text-primary);
      }
      .lw-tooltip {
        position: absolute;
        z-index: 100;
        pointer-events: none;
        padding: 12px;
        border-radius: var(--dees-radius-lg);
        border: 1px solid;
        font-family: var(--dees-font-family);
        font-size: 12px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
        min-width: 140px;
      }
      @media (max-width: 480px) {
        .statsSeries { flex-wrap: wrap; gap: 4px 8px; }
        .statsSeries + .statsSeries { border: 0; padding-left: 0; }
      }
    `,
  ];
